import React from 'react'
import { requireAuthentication } from '../helpers/authentication'
import DashboardResults from './Results'
import DashboardControl from './Control'
import { Typography } from 'antd'
import { DEFAULT_TIME_AFTER_TEST } from './constants'
import { useLocalStorage } from 'react-use'
import { FormattedMessage, injectIntl } from 'react-intl'
import { useGetUserTestZones } from '../hooks/TestZones'

import './styles.scss'
const { Title } = Typography

function ProductionLinePage() {
  const [searchTerm, setSearchTerm] = useLocalStorage(
    'production-line-search-query-object',
    { plant: null, testZones: [], timeAfterTest: DEFAULT_TIME_AFTER_TEST },
  )
  const { status, allTestZones, error } = useGetUserTestZones()

  return (
    <div id="production-line-page">
      <div className="page-name">
        <Title level={3}>
          <FormattedMessage id="productionLineDashboard.routeLabel" />
        </Title>
      </div>
      <div className="production-line-content">
        <DashboardControl
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          allTestZones={allTestZones}
          status={status}
          error={error}
        />
        <DashboardResults searchTerm={searchTerm} allTestZones={allTestZones} />
      </div>
    </div>
  )
}

export default requireAuthentication(injectIntl(ProductionLinePage))
